import type { Node } from 'react'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Footer } from 'app/common/footer'
import type { HeaderBackground } from 'app/common/header'
import { Header } from 'app/common/header'
import { CookiesConsent } from 'app/common/cookies/consent'
import { isAndroid } from 'react-device-detect'
import { colors } from 'app-v2/design-systems'
import { Text } from '../typography'
import { featureCodes } from 'shared/utils'
import { FeatureToggle } from '../feature-toggle'

type Props = {
    headerShouldStick?: boolean,
    border?: boolean,
    color?: string,
    background?: HeaderBackground,
    backgroundColor?: string,
    children?: Node,
    withQuickSearch?: boolean,
    showAppBanner?: boolean
}

export const LayoutDisplayComponent = ({
    children,
    headerShouldStick = true,
    withQuickSearch = true,
    border,
    color,
    background,
    backgroundColor,
    showAppBanner
}: Props) => {
    return (
        <Main
            backgroundColor={backgroundColor}
            showAppBanner={showAppBanner}
            headerShouldStick={headerShouldStick}>
            <Header
                shouldStick={headerShouldStick}
                border={border}
                color={color}
                background={background}
                withQuickSearch={withQuickSearch}
            />
            {children}
            <Footer />
            {process.env.REACT_APP_ENABLE_ONETRUST !== 'true' && (
                <FeatureToggle features={[featureCodes.ENABLE_COOKIES_CONSENT]}>
                    <CookiesConsent />
                </FeatureToggle>
            )}
        </Main>
    )
}

const Main = styled.main`
    position: relative;
    overflow-x: hidden;
    ${({ backgroundColor }) =>
        backgroundColor && `background-color: ${backgroundColor}`}
    ${({ showAppBanner, headerShouldStick }) =>
        isAndroid && showAppBanner && headerShouldStick && 'margin-top: 80px'};
`
